import { Pipe, PipeTransform } from '@angular/core';

const DefaultMaxChars = 20;

@Pipe({
  name: 'crmTruncate',
  standalone: true,
})
export class CrmTruncatePipe implements PipeTransform {
  transform(text?: string, maxChars?: number, hideEllipsis?: boolean): string {
    const max = maxChars || DefaultMaxChars;
    if (!text) {
      return '';
    }
    if (text.length <= max) {
      return text;
    }

    if (hideEllipsis) {
      return text.slice(0, max);
    }
    return text.slice(0, max) + '...';
  }
}
